<template>
  <v-card class="mt-3 result-overview-component">
    <v-toolbar color="primary" flat dark>
      <v-toolbar-title>Quiz Results</v-toolbar-title>
    </v-toolbar>
    <v-card-actions class="px-4 pt-4">
      <v-select
        v-if="me.type === 'student'"
        v-model="selectedClass"
        class="select mr-3"
        :items="classes"
        item-value="value"
        item-text="text"
        label="Select Class"
        hide-details
      />
      <v-select
        v-model="selectedLesson"
        class="select"
        :items="lessons"
        item-value="value"
        item-text="text"
        :label="`Select ${this.capitalizeFirstLetter(this.lessonTerm)}s`"
        hide-details
      />
      <v-spacer />
    </v-card-actions>
    <div class="pa-4 bar-chart">
      <bar-chart ref="chart" :chart-data="resultData" />
    </div>
  </v-card>
</template>

<script>
import _ from 'lodash'
import UserLesson from '@/modules/lesson/models/UserLesson'
import BarChart from '@/components/charts/BarChart'
import Class from '@/modules/class/models/Class'
import Lesson from '@/modules/lesson/models/Lesson'
import Auth from '@/modules/auth/models/Auth'
import { mapState } from 'vuex'

export default {
  name: 'ResultOverview',
  components: {
    BarChart
  },
  data() {
    return {
      ready: false,
      dataCollection: null,
      selectedClass: '',
      selectedLesson: ''
    }
  },
  watch: {
    selectedLesson() {
      this.fillData()
    }
  },
  computed: {
    ...mapState(['lessonTerm']),
    me() {
      return Auth.query()
        .where('type', this.$route.meta.type)
        .first()
    },
    studentLessons() {
      if (!this.me) return []

      const userLessons = UserLesson.query()
        .where('entity_id', this.me.id)
        .where('is_completed', true)
        .orderBy('completed_at', 'desc')
        .limit(5)
        .get()

      if (!userLessons) return []
      return userLessons
    },
    lessons() {
      return [
        {
          text: '-- All --',
          value: ''
        }
      ].concat(
        Lesson.all().map(c => {
          return { text: c.name, value: c.id }
        })
      )
    },
    classes() {
      return [
        {
          text: '-- All --',
          value: ''
        }
      ].concat(
        Class.all().map(c => {
          return { text: c.name, value: c.id }
        })
      )
    },
    resultData() {
      let filteredLessons = this.studentLessons
      filteredLessons.sort(function(a, b) {
        return new Date(a.completed_at) - new Date(b.completed_at)
      })

      let labels = []
      let prequiz = {
        label: 'Pre Quiz',
        stack: 1,
        backgroundColor: '#00ABD7',
        data: []
      }

      let postquiz = {
        label: 'Post Quiz',
        stack: 1,
        backgroundColor: '#8AFBFF',
        data: []
      }

      if (this.selectedClass != '') {
        filteredLessons = filteredLessons.filter(e => {
          return e.custom_class_id === this.selectedClass
        })
      }

      if (this.selectedLesson != '') {
        filteredLessons = filteredLessons.filter(e => {
          return e.lesson_id === this.selectedLesson
        })
      }

      if (!this.studentLessons || !filteredLessons.length) {
        labels = ['- Lesson Not Available -']
        prequiz.data = [0]
        postquiz.data = [0]
        return { labels, datasets: [prequiz, postquiz] }
      }

      _.forEach(filteredLessons, value => {
        if (!value.completed_at) return
        let lesson = Lesson.find(value.lesson_id)
        if (!lesson) return
        labels = [
          ...labels,
          [
            _.capitalize(lesson.name),
            value.completed_at
              ? this.$moment(value.completed_at).format('DD MMM YYYY')
              : '- Lesson Incomplete -'
          ]
        ]
        prequiz['data'] = [...prequiz['data'], value.pre_quiz]
        postquiz['data'] = [...postquiz['data'], value.post_quiz]
        //        console.log({ labels: labels })
      })
      // console.log({ return: { labels, datasets: [prequiz, postquiz] } })
      return { labels, datasets: [prequiz, postquiz] }
    }
  },
  async mounted() {
    this.ready = false
    await UserLesson.dispatch('fetchAll', this.me.type + 's')
    await Lesson.dispatch('fetch', this.$route.meta.type)
    this.$nextTick(() => {
      // this.fillData()
      setTimeout(() => {
        this.$refs.chart.updateChart()
        this.ready = true
        this.$emit('loaded')
      }, 2000)
    })
  },
  methods: {
    fillData() {
      let filteredLessons = this.studentLessons
      let chart = {}
      let preQuizData = {
        label: 'Pre Quiz',
        stack: 1,
        backgroundColor: '#00ABD7',
        data: []
      }
      let postQuizData = {
        label: 'Post Quiz',
        stack: 1,
        backgroundColor: '#8AFBFF',
        data: []
      }
      chart.labels = []

      if (this.selectedClass != '') {
        filteredLessons = filteredLessons.filter(e => {
          return e.custom_class_id === this.selectedClass
        })
      }

      if (this.selectedLesson != '') {
        filteredLessons = filteredLessons.filter(e => {
          return e.lesson_id === this.selectedLesson
        })
      }
      _.forEach(filteredLessons, value => {
        let lesson = Lesson.find(value.lesson_id)
        chart.labels.push([lesson.name])
        preQuizData.data.push(value.pre_quiz)
        postQuizData.data.push(value.post_quiz)
      })
      chart.datasets = [preQuizData, postQuizData]

      this.dataCollection = JSON.parse(JSON.stringify(chart))
    }
  },
  getLabels() {}
}
</script>

<style lang="scss">
.result-overview-component {
  .select {
    max-width: 200px;
  }
  .bar-chart {
    > div {
      max-height: 300px;
      width: 100%;
      #bar-chart {
        max-height: 300px;
      }
    }
  }
}
</style>
